module.exports = __webpack_public_path__ + "img/timeIcon.77d5f11f.svg";